__turbopack_context__.v({
  "avatar": "index-module-scss-module__jlkUrG__avatar",
  "bullet": "index-module-scss-module__jlkUrG__bullet",
  "button": "index-module-scss-module__jlkUrG__button",
  "c_slide_active": "index-module-scss-module__jlkUrG__c_slide_active",
  "card": "index-module-scss-module__jlkUrG__card",
  "collapsed": "index-module-scss-module__jlkUrG__collapsed",
  "container": "index-module-scss-module__jlkUrG__container",
  "header": "index-module-scss-module__jlkUrG__header",
  "heading": "index-module-scss-module__jlkUrG__heading",
  "innerContainer": "index-module-scss-module__jlkUrG__innerContainer",
  "name": "index-module-scss-module__jlkUrG__name",
  "nameDiv": "index-module-scss-module__jlkUrG__nameDiv",
  "pagination": "index-module-scss-module__jlkUrG__pagination",
  "root": "index-module-scss-module__jlkUrG__root",
  "stars": "index-module-scss-module__jlkUrG__stars",
  "testimonial_student_carousel": "index-module-scss-module__jlkUrG__testimonial_student_carousel",
  "text": "index-module-scss-module__jlkUrG__text",
  "textWrapper": "index-module-scss-module__jlkUrG__textWrapper",
  "title": "index-module-scss-module__jlkUrG__title",
});
